import { resetPageRequests } from '@/utils/pageRequests';
import store from "@/store";
import Vue from "vue";
import VueRouter from "vue-router";
import i18n from "@/i18n";

import SignInApi from "@/api/user/signIn";
import AiTraderApi from "@/api/aiTrader";
let signInHttp = new SignInApi();
let aiTraderHttp = new AiTraderApi();
let signIn = null;
let signInTime = 0;
let signInArr = [];

// Guard for AI trader admin-only routes. Fetches is_admin lazily, caches in Vuex,
// redirects non-admins to the public list page. Requires login (redirects via SET_IS_SHOW_LOGIN).
function requireAiTraderAdmin(to, from, next) {
  if (!store.state.token) {
    store.commit('SET_IS_SHOW_LOGIN', true);
    return next({ name: 'aiTrader' });
  }
  const cached = store.state.aiTraderIsAdmin;
  if (cached === true) return next();
  if (cached === false) return next({ name: 'aiTrader' });
  aiTraderHttp.isAdmin().then(res => {
    const ok = !!(res && res.data && res.data.is_admin);
    store.commit('SET_AI_TRADER_IS_ADMIN', ok);
    next(ok ? undefined : { name: 'aiTrader' });
  }).catch(() => next({ name: 'aiTrader' }));
}

Vue.use(VueRouter);

const routes = [
  {
    path: '/ui-lab',
    redirect: '/market',
  },
  {
    path: '/ui-lab-okx',
    redirect: '/market',
  },
  {
    path: '/',
    redirect: '/market',
    component: () => import('@/views/uiLabOkx/index'),
    children: [
      {
        name: 'contact',
        path: '/contact',
        meta: { title: '聯絡我們', isNeedLogin: false },
        component: () => import('@/views/platform/contact.vue'),
      },
      {
        name: 'market',
        path: '/market',
        meta: { title: '行情', isNeedLogin: false },
        component: () => import('@/views/market/index'),
      },
      {
        name: 'platform',
        path: '/platform',
        meta: { title: '平台', isNeedLogin: false },
        component: () => import('@/views/platform/index'),
      },
      {
        name: 'etf',
        path: '/etf',
        meta: { title: 'ETF', isNeedLogin: false },
        component: () => import('@/views/etf/index'),
      },
      { name: 'calendar', path: '/calendar', redirect: { name: 'consult', query: { tab: 'calendar' } } },
      {
        name: 'publicChain',
        path: '/publicChain',
        meta: { title: '公链', isNeedLogin: false },
        component: () => import('@/views/publicChain/index'),
      },
      {
        name: 'inscription',
        path: '/inscription',
        meta: { title: '铭文', isNeedLogin: false },
        component: () => import('@/views/inscription/index'),
      },
      {
        name: 'burst',
        path: '/burst',
        meta: { title: '爆仓', isNeedLogin: false },
        component: () => import('@/views/burst/index'),
      },
      {
        name: 'burstStatistics',
        path: '/burstStatistics',
        meta: { title: '爆仓-统计', isNeedLogin: false },
        component: () => import('@/views/burst/burstStatistics'),
      },
      {
        name: 'burstHeatmapDetails',
        path: '/burstHeatmapDetails',
        meta: { title: '爆仓-热力图数据', isNeedLogin: false },
        component: () => import('@/views/burst/heatmapDetails'),
      },
      {
        name: 'manyEmpty',
        path: '/manyEmpty',
        meta: { title: '多空', isNeedLogin: false },
        component: () => import('@/views/manyEmpty/index'),
      },
      {
        name: 'whale',
        path: '/whale',
        meta: { title: '巨鲸', isNeedLogin: false },
        component: () => import('@/views/whale/index'),
      },
      {
        name: 'rate',
        path: '/rate',
        meta: { title: '费率', isNeedLogin: false },
        component: () => import('@/views/rate/index'),
      },
      {
        name: 'hyperliquid',
        path: '/hyperliquid',
        meta: { title: 'Hyperliquid', isNeedLogin: false },
        component: () => import('@/views/hyperliquid/index'),
      },
      {
        name: 'consult',
        path: '/consult',
        meta: { title: '咨询', isNeedLogin: false },
        component: () => import('@/views/consult/index'),
      },
      {
        name: 'application',
        path: '/application',
        meta: { title: '应用', isNeedLogin: false },
        component: () => import('@/views/application/index'),
      },
      {
        name: 'hyperliquidDetails',
        path: '/hyperliquidDetails/:user',
        meta: { title: 'Hyperliquid详情', isNeedLogin: false },
        component: () => import('@/views/hyperliquid/details'),
      },
      {
        path: '/smartMoney',
        redirect: { name: 'market' },
      },
      {
        name: 'smartMoneyDetails',
        path: '/smartMoneyDetails/:address',
        meta: { title: '聪明钱-明细', isNeedLogin: false },
        component: () => import('@/views/smartMoney/details'),
      },
      {
        name: 'coinDetails',
        path: '/coinDetails',
        meta: { title: '币种详情', isNeedLogin: false },
        component: () => import('@/components/coinDetails'),
      },
      {
        name: 'newCoinDetails',
        path: '/newCoinDetails',
        meta: { title: '新币种详情', isNeedLogin: false },
        component: () => import('@/components/newCoinDetails'),
      },
      {
        name: 'consultDetails',
        path: '/consultDetails/:id/:type',
        meta: { title: '资讯-详情', isNeedLogin: false },
        component: () => import('@/views/consult/details'),
      },
      {
        name: 'platformDetails',
        path: '/platformDetails',
        meta: { title: '平台-详情', isNeedLogin: false },
        component: () => import('@/components/platformDetails'),
      },
      {
        name: 'firmOffer',
        path: '/firmOffer',
        meta: { title: '实盘', isNeedLogin: false },
        component: () => import('@/views/firmOffer/index'),
      },
      {
        name: 'userSignIn',
        path: '/userSignIn',
        meta: { title: '用户中心-签到', isNeedLogin: false },
        component: () => import('@/views/user/signIn'),
      },
      {
        name: 'userSignInRecord',
        path: '/userSignInRecord',
        meta: { title: '用户中心-签到记录', isNeedLogin: false },
        component: () => import('@/views/user/signInRecord'),
      },
      {
        name: 'userWithdrawalRecord',
        path: '/userWithdrawalRecord',
        meta: { title: '用户中心-提币记录', isNeedLogin: false },
        component: () => import('@/views/user/withdrawalRecord'),
      },
      {
        name: 'userInvite',
        path: '/userInvite',
        meta: { title: '用户中心-邀请', isNeedLogin: false },
        component: () => import('@/views/user/invite'),
      },
      {
        name: 'userBindingApi',
        path: '/userBindingApi',
        meta: { title: '用户中心-绑定API', isNeedLogin: false },
        component: () => import('@/views/user/bindingApi'),
      },
      {
        name: 'userHitNewRobot',
        path: '/userHitNewRobot',
        meta: { title: '用户中心-打新机器人', isNeedLogin: false },
        component: () => import('@/views/user/hitNewRobot'),
      },
      {
        name: 'userHitNewRobotInfo',
        path: '/userHitNewRobotInfo',
        meta: { title: '用户中心-Token代币实时信息', isNeedLogin: false },
        component: () => import('@/views/user/hitNewRobotInfo'),
      },
      {
        name: 'userHitNewRobotRule',
        path: '/userHitNewRobotRule',
        meta: { title: '用户中心-打新机器人规则', isNeedLogin: false },
        component: () => import('@/views/user/hitNewRobotRule'),
      },
      {
        name: 'userContractCheck',
        path: '/userContractCheck',
        meta: { title: '用户中心-合约检查', isNeedLogin: false },
        component: () => import('@/views/user/contractCheck'),
      },
      {
        name: 'userCollect',
        path: '/userCollect',
        meta: { title: '用户中心-收藏', isNeedLogin: false },
        component: () => import('@/views/user/collect'),
      },
      {
        name: 'userTrace',
        path: '/userTrace',
        meta: { title: '用户中心-追踪', isNeedLogin: false },
        component: () => import('@/views/user/trace'),
      },
      {
        name: 'userTeam',
        path: '/userTeam',
        meta: { title: '用户中心-团队', isNeedLogin: false },
        component: () => import('@/views/user/team'),
      },
      {
        name: 'userForum',
        path: '/userForum',
        meta: { title: '用户中心-论坛', isNeedLogin: false },
        component: () => import('@/views/user/forum'),
      },
      {
        name: 'userTool',
        path: '/userTool',
        meta: { title: '用户中心-工具', isNeedLogin: false },
        component: () => import('@/views/user/tool'),
      },
      {
        name: "userToolCompanyHoldings",
        path: "/userToolCompanyHoldings",
        meta: { title: '工具-BTC公司持仓', isNeedLogin: false },
        component: () => import("../views/tool/companyHoldings"),
      },
      {
        name: "userToolSentimentIndex",
        path: "/userToolSentimentIndex",
        meta: { title: '工具-情绪指数', isNeedLogin: false },
        component: () => import("../views/tool/sentimentIndex"),
      },
      {
        name: "userToolMTGoxMonitor",
        path: "/userToolMTGoxMonitor",
        meta: { title: '工具-门头沟监控', isNeedLogin: false },
        component: () => import("../views/tool/MTGoxMonitor"),
      },
      {
        name: "userToolOutsidePrice",
        path: "/userToolOutsidePrice",
        meta: { title: '工具-场外价格', isNeedLogin: false },
        component: () => import("../views/tool/outsidePrice"),
      },
      {
        name: "userToolOutsideDisk",
        path: "/userToolOutsideDisk",
        meta: { title: '工具-外盘数据', isNeedLogin: false },
        component: () => import("../views/tool/outsideDisk"),
      },
      {
        name: "userToolLargeIncrease",
        path: "/userToolLargeIncrease",
        meta: { title: '工具-大户增仓', isNeedLogin: false },
        component: () => import("../views/tool/largeIncrease"),
      },
      {
        name: "userToolLargeDecrease",
        path: "/userToolLargeDecrease",
        meta: { title: '工具-大户减仓', isNeedLogin: false },
        component: () => import("../views/tool/largeDecrease"),
      },
      {
        name: "userToolStableCoin",
        path: "/userToolStableCoin",
        meta: { title: '工具-稳定币', isNeedLogin: false },
        component: () => import("../views/tool/stableCoin"),
      },
      {
        name: "userToolBlockChainBrowser",
        path: "/userToolBlockChainBrowser",
        meta: { title: '工具-区块链浏览器', isNeedLogin: false },
        component: () => import("../views/tool/blockChainBrowser"),
      },
      {
        name: 'aiTrader',
        path: '/aiTrader',
        meta: { title: 'AI交易', isNeedLogin: true },
        component: () => import('@/views/aiTrader/index'),
      },
      {
        name: 'aiTraderDashboard',
        path: '/aiTraderDashboard',
        meta: { title: 'AI交易-看板', isNeedLogin: true },
        component: () => import('@/views/aiTrader/dashboard'),
      },
      {
        name: 'aiTraderCreate',
        path: '/aiTraderCreate',
        meta: { title: 'AI交易-创建', isNeedLogin: true },
        beforeEnter: requireAiTraderAdmin,
        component: () => import('@/views/aiTrader/create'),
      },
      {
        name: 'aiTraderDetail',
        path: '/aiTraderDetail/:id',
        meta: { title: 'AI交易-详情', isNeedLogin: true },
        component: () => import('@/views/aiTrader/detail'),
      },
      {
        name: 'aiTraderBacktest',
        path: '/aiTraderBacktest',
        meta: { title: 'AI交易-回测', isNeedLogin: true },
        beforeEnter: requireAiTraderAdmin,
        component: () => import('@/views/aiTrader/backtest'),
      },
    ]
  }
];

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

const router = new VueRouter({
  routes,
  scrollBehavior () {
    return { x: 0, y: 0 }
  }
});

// IP 检测只执行一次
let ipChecked = false;

router.beforeEach((to, from, next) => {
  // 只在首次加载且未设置语言时检测 IP
  if (!ipChecked && !store.state.language?.type) {
    ipChecked = true;
    const xhr = new XMLHttpRequest();
    xhr.open('get', 'https://api.ipify.org');
    xhr.send();
    xhr.onreadystatechange = function() {
      if (xhr.readyState === 4 && xhr.status === 200) {
        store.commit('SET_IP', xhr.responseText);
        const xhr2 = new XMLHttpRequest();
        xhr2.open('get', `https://ipinfo.io/${xhr.responseText}/json`);
        xhr2.send();
        xhr2.onreadystatechange = function() {
          if (xhr2.readyState === 4 && xhr2.status === 200) {
            let xhr2Response = JSON.parse(xhr2.responseText)
            if (!store.state.language?.type) {
              if (xhr2Response.country === 'CN') {
                store.commit('SET_LANGUAGE', { text: '中文-简体', type: 'zh_CN'});
                i18n.locale = 'zh_CN';
              } else {
                // Default to Traditional Chinese for HK/TW and everyone else.
                store.commit('SET_LANGUAGE', { text: '中文-繁體', type: 'zh_TW'});
                i18n.locale = 'zh_TW';
              }
            }
          }
        }
      }
    }
  }
  next();
});

router.afterEach((to, from) => {
  resetPageRequests();
  if (store.state.token) {
    if (!signInArr.includes(from.name)) {
      signInHttp.signInCount({num: signInTime});
      clearInterval(signIn);
    }
    if (!signInArr.includes(to.name)) {
      signInTime = 0;
      signIn = setInterval(() => {
        signInTime += 1;
      }, 1000);
    }
  }
})

export default router;
